// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ac1fb1c5","654":"c840dbaf"}[chunkId] + ".chunk.js";
};